import React from 'react';
import { Link } from 'react-router-dom';
import coachLogo from '../../assets/images/coach.png';
import etLogo from '../../assets/images/coachet.jpg';

const Footer = () => {
  let date = new Date();
  let year = date.getFullYear();
  return (

    <footer className="bg-gradient-to-b from-blue-500 to-blue-700 text-white py-8 lg:px-16">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between">
        {/* Section 1: Tagline */}
        <div className="mb-8 md:mb-0">
          <p className="mb-4 lg:w-[300px]">
            Rediscover Greatness Within <br /> Through Executive Coaching
          </p>
          <div className="flex space-x-4 mb-4">
            {/* <a href="https://www.facebook.com" target="_blank" rel="noreferrer" className="text-white">
              <i className="fab fa-facebook-f"></i>
            </a>
           
            <a href="https://twitter.com" target="_blank" rel="noreferrer" className="text-white">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://pinterest.com" target="_blank" rel="noreferrer" className="text-white">
              <i className="fab fa-pinterest"></i>
            </a> */}
            <a href="https://www.linkedin.com/in/coachkshitij/" target="_blank" rel="noreferrer" className="text-white">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="https://www.youtube.com/@coachkshitij8459" target="_blank" rel="noreferrer" className="text-white">
              <i className="fab fa-youtube"></i>
            </a>
            {/* <a href="https://www.ted.com/tedx" target="_blank" rel="noreferrer" className="text-white">
              <i className="fab fa-ted"></i>
            </a> */}
          </div>
          <p>{year} <a href="https://coachkshitij.com" className="text-white">Coach Kshitij</a>. All Rights Reserved</p>
<p><br/>
  Powered by <a href="https://kaitensoftware.com" target="_blank" rel="noopener noreferrer">Kaiten Software</a>
</p>
        </div>

        {/* Section 2: Awards & Recognition */}
        <div className="mb-8 flex items-center justify-center gap-6 p-4 sm:flex-nowrap">
          {/* ET Achievers Logo with Increased Width */}
          <a
            href="https://economictimes.indiatimes.com/industry/miscellaneous/et-achievers-2022-dynamic-achievers-ride-high-on-success/articleshow/94505352.cms"
            target="_blank"
            rel="noreferrer"
            className="flex flex-col items-center w-[150px] sm:w-[180px]"
          >
            <img
              className="rounded-lg w-[120px] sm:w-[180px] lg:w-[170px]"
              src={etLogo}
              alt="ET Achievers Logo"
            />
          </a>

          <a
            href="https://coachfoundation.com/blog/top-executive-coaches/"
            target="_blank"
            rel="noreferrer"
            className="flex flex-col items-center w-[150px] sm:w-[180px]"
          >
            <img
              className="rounded-lg w-[120px] sm:w-[150px] lg:w-[170px]"
              src={coachLogo}
              alt="Coach Foundation Logo"
            />
            <p className="text-center text-sm mt-2 sm:mt-0 lg:mt-2">
              TOP Executive Coach 2021 Edition
            </p>
          </a>
        </div>



        {/* Section 3: Offerings */}
        <div className="mb-8 md:mb-0">
          <h3  style={{ fontFamily: "Helvetica" }} className="font-bold mb-4">Programs</h3>
          <ul>
            <li className="mb-2">
              <a href="https://coachkshitij.com" className="text-white" target="_blank" rel="noopener noreferrer">
                Executive Coaching
              </a>
            </li>
            <li className="mb-2">
              <a href="https://coachkshitij.com/women-leadership-coaching/" className="text-white" target="_blank" rel="noopener noreferrer">
                Women Leadership Coaching
              </a>
            </li>
            <li className="mb-2">
              <a href="https://coachkshitij.com/positive-intelligence-coaching-program/" className="text-white" target="_blank" rel="noopener noreferrer">
                Positive Intelligence Boot Camp
              </a>
            </li>
          </ul>
        </div>

        {/* Section 4: Contact Information */}
        <div   style={{ fontFamily: "Helvetica" }} className="mb-8 md:mb-0 lg:ml-1">
          <h3  style={{ fontFamily: "Helvetica" }} className="font-bold mb-4">Contact Information</h3>
          <ul>
            <li className="mb-2">
              <a href="tel:+919980473772" className="text-white">
                <i className="fas fa-phone-alt mr-2"></i> +91 9980473772
              </a>
            </li>
            <li className="mb-2">
              <a href="mailto:support@coachkshitij.com" className="text-white">
                <i className="fas fa-envelope mr-2"></i> support@coachkshitij.com
              </a>
            </li>
            <li className="mb-2">
              <a href="https://goo.gl/maps/X9J5c" target="_blank" rel="noreferrer" className="text-white">
                <i className="fas fa-map-marker-alt mr-2"></i> DHI Innovation Hub, Arekere Bangalore, KA
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-center lg:mt-0  mt-8">
        <div className="text-sm text-center">
          <p className='lg:hidden'>{year} <a href="https://coachkshitij.com" className="text-white">Coach Kshitij</a>. All Rights Reserved</p>

            <p className='lg:hidden'>Powered by Kaiten Software</p>

        </div>
        {/* <div className="flex space-x-4 text-sm">
          <Link to="/terms-conditions" className="text-white">Terms & Conditions</Link>
          <Link to="/privacy-policy" className="text-white">Privacy Policy</Link>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
